import React from 'react'
import SectionTitle from '../../CommonComponents/SectionTitle.jsx/SectionTitle';
import ServiceDetails from './ServiceDetails/ServiceDetails';
import './serviceStyle.css'
export default function Service() {
 return (
  
  <div className="container pt-5" id="service">   
    <SectionTitle
      title="Our Services"
      detail="At Doctor Care, we are proud to offer a comprehensive range of healthcare services designed to meet your diverse medical needs. Our commitment to your well-being extends across several key areas, ensuring you receive exceptional care and support."
    />     
    <ServiceDetails/>
  </div>
 
 )
}
